class Api {
    static init() {
        Api.#realTableRWD();
        Api.#chartFilters();
        Api.#tableFilters();
        Api.#simpleTabs();
        Api.#radioTab();
        Api.#infoAuthorizationPopup();
        Api.#afterLoginModal();
        ApiServicesAccordion.init(); //zarządzanie usługami w edycji firmy - accordion
        ApiCheckboxTree.init(); //zarządzanie drzewem checkboxów w edycji DDoS firmy
        ApiUserAuthenticateConfig.init(); //dodaje obsługę wyboru typu autentykacji w ustawieniach użytkownika
        ApiForms.init(); //elementy związane z formularzami
        ApiCmsFixLayout.init(); //elementy związane z funkcjonalnością ogólnego layoutu
        ApiLogin.init(); //strona logowania
        ApiNotification.init(); //notyfikacje

        const $authorizationInfoModal = $('#authorizationInfoModal');
        const $afterLoginModal = $('#afterLoginModal');

        if ($authorizationInfoModal.length) {
            $authorizationInfoModal.modal('show'); //odpalenie modalu
        }

        if ($afterLoginModal.length) {
            $afterLoginModal.modal('show'); //odpalenie modalu
        }
    }

    static #realTableRWD() {
        $('.table').each(function() {
            const $tr = $(this).find('tbody tr');

            $(this).find('thead th').each(function(i) {

                const text = $(this).text();
                const reg = new RegExp('[a-z]', 'i');
                if (reg.test(text)) {
                    $tr.each(function() {
                        $(this).find('td:eq(' + i + ')').attr('data-td-title', text).addClass('rwd');
                    })
                }
            })
        })
    };

    static #radioTab() {
        // noinspection JSUnusedLocalSymbols
        $('.tabs-radio input:radio').on('click', function(e) {
            const $target = $($(this).attr('data-target'));
            $target.siblings().hide();
            $target.fadeIn();
        })
    };

    static #simpleTabs() {
        $('.char-tab-toggle').on('click', function(e) {
            e.preventDefault();
            const $target = $($(this).attr('href'));
            if ($target.length) {
                $target.siblings().removeClass('active');
                $target.addClass('active');
            }
            $(this).closest('.card-header').find('h2').text($(this).text());
        })
    };

    static #chartFilters() {
        if (!$('.filterData').is(':checked')) {
            $('.filters').hide();
        }

        $('#datePeriod_periodType input[type=radio]').on('click', function() {
            if ($(this).val() === 'period') {
                $('.filters').show('fast');
            } else {
                $('.filters').hide('fast');
            }
        });
        
        if ($('#datePeriod_periodType input[type=radio][value=period]').is(':checked')) {
            $('.filters').show();
        } else {
            $('.filters').hide();
        }

    };

    static #tableFilters() {
        if (!$('.filterData').is(':checked')) {
            $('.table-filters').hide();
        }

        $('#datePeriod_tablePeriodType input[type=radio]').on('click', function() {
            if ($(this).val() === 'period') {
                $('.table-filters').show('fast');
            } else {
                $('.table-filters').hide('fast');
            }
        });

        if ($('#datePeriod_tablePeriodType input[type=radio][value=period]').is(':checked')) {
            $('.table-filters').show();
        } else {
            $('.table-filters').hide();
        }

    };

    //zamykam popup z informacja o logowaniu. Po kliknięciu w przycisk ustawiam cookie
    static #infoAuthorizationPopup() {
        $('#authorizationInfoModal .btn').on('click', function() {
            Cookies.set('howAuthorizationInfoModalShowed', '1');
        });
    };

    //zamykam popup na stronie głównej po logowaniu. Po kliknięciu w przycisk zamknij ustawiam cookie na dobę
    static #afterLoginModal() {
        $('#afterLoginModal .btn').on('click', function() {
            const date = new Date();
            date.setDate(date.getDate() + 1);
            Cookies.set('popup_after_login_showed', '1', { expires: date });
        });
    };
}

$(function() {
    Api.init();
});
